// @ts-nocheck
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Tag } from 'antd';
import qs from 'qs';
import { Content, CustomType } from 'mdello-client-ts/dist/src/types/mdello/cms.type';
import { useGetContentModelsQuery } from 'src/reactQuery/contentModels/queries/useGetContentModelsQuery';
import { useGetContentsQuery } from 'src/reactQuery/Content/useGetContents';
import Loader from 'src/component/Loader/Loader';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';
import { fetchContent } from '../../actions/ContentAction';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';

interface MappedContent {
  _id: string;
  by: string;
  contentType: string;
  created: string;
  // eslint-disable-next-line camelcase
  custom_type: CustomType;
  key: number;
  name: string;
  status: string;
  updated: string;
}

const Highlighted = () => {
  const history = useHistory();
  const urlLocation = useLocation();
  const { data: customTypes, isLoading: isLoadingContentModel } = useGetContentModelsQuery();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const params = qs.parse(urlLocation.search, { ignoreQueryPrefix: true });
  const isFilterArray = Array.isArray(params.filter);

  const { data: contentData, isLoading: isLoadingContent } = useGetContentsQuery({
    customTypeId: isFilterArray && params.filter ? params.filter[0] : params.filter,
    isHighlighted: '1',
    orderBy: params.orderBy?.toString(),
    orderDirection: params.orderDirection?.toString(),
    page: params.page?.toString(),
    pageSize: params.pageSize?.toString(),
    searchItem: params.search?.toString()
  });

  const mapToTable = (content: Content<any>[] | undefined) => {
    const data: MappedContent[] = [];

    if (!content || content.length === 0) {
      return data;
    }

    content.forEach(
      // @ts-ignore
      // eslint-disable-next-line camelcase
      ({ _id, name, customTypeName, created, updated, status, custom_type }, index) => {
        const createdDate = formatDate(created);
        const updatedDate = formatDate(updated);
        // if (!customTypeName) return;
        data.push({
          _id,
          by: 'Me',
          contentType: customTypeName,
          created: createdDate,
          custom_type,
          key: index,
          name,
          status,
          updated: updatedDate
        });
      }
    );
    return data;
  };

  const openDetail = (item: MappedContent) => {
    history.push(`/content/${item._id}`);
  };

  const columns = [
    {
      dataIndex: 'name',
      key: 'name',
      render: (name: string) => {
        return (
          <div
            style={{
              color: 'black',
              fontWeight: 700
              // width: "256px",
              // textAlign: "start",
            }}
          >
            <Copy text={name} />
          </div>
        );
      },
      sorter: (a: MappedContent, b: MappedContent) => a.name.localeCompare(b.name),
      title: 'Name'
    },
    {
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag
          key={status}
          style={
            status === 'published'
              ? {
                  backgroundColor: 'rgba(65, 204, 156, 0.15)',
                  border: 'none',
                  color: '#41CC9C',
                  width: '100%'
                }
              : {
                  backgroundColor: 'rgba(244, 211, 37, 0.15)',
                  border: 'none',
                  color: '#F4CD00',
                  width: '100%'
                }
          }
        >
          {status}
        </Tag>
      ),
      sorter: (a: MappedContent, b: MappedContent) => a.status.localeCompare(b.status),
      title: 'Status'
    },
    {
      dataIndex: 'contentType',
      key: 'contentType',
      render: (contentType: string) => {
        return <Copy text={contentType} />;
      },
      sorter: true,
      title: 'Content Model'
    },
    {
      dataIndex: 'created',
      key: 'created',
      render: (created: string) => {
        return <Copy text={created} />;
      },
      // @ts-ignore
      sorter: (a: MappedContent, b: MappedContent) => new Date(a.created) - new Date(b.created),
      title: 'Created'
    },
    {
      dataIndex: 'updated',
      key: 'updated',
      render: (update: string) => {
        return <Copy text={update} />;
      },
      // @ts-ignore
      sorter: (a: MappedContent, b: MappedContent) => new Date(a.updated) - new Date(b.updated),
      title: 'Updated'
    },
    {
      dataIndex: 'by',
      key: 'by',
      render: (by: string) => {
        return <Copy text={by} />;
      },
      sorter: (a: MappedContent, b: MappedContent) => a.by.localeCompare(b.by),
      title: 'Author'
    },
    {
      key: 'edit',
      render: (item: MappedContent) => {
        return <Tag onClick={() => openDetail(item)}>edit</Tag>;
      }
    }
  ];

  const getInitialFilterFromUrl = () => {
    const { filter } = qs.parse(urlLocation.search, {
      ignoreQueryPrefix: true
    });

    if (typeof filter === 'string') {
      const selectedCustomType = customTypes?.find((customType) => customType._id === filter);
      const newFilter = selectedCustomType?.name;
      return [newFilter, 'All'];
    }

    if (filter && filter[0] && filter[0] !== 'All') {
      const customTypeId = filter[0];
      const selectedCustomType = customTypes?.find((customType) => customType._id === customTypeId);
      filter[0] = selectedCustomType?.name;
    }

    return filter || [filterListContentModel[0], filterListStatus[0]];
  };

  if (isLoadingContent && isLoadingContentModel) {
    return <Loader />;
  }

  const data = mapToTable(contentData?.content);

  const filterListContentModel = ['All', ...new Set(customTypes?.map((item) => item.name))];
  const filterListStatus = ['All', ...new Set(data.map((item) => item.status))];

  // eslint-disable-next-line no-unused-vars
  const onFilterChange = (value, index, selectedFilter) => {
    if (index === 0) {
      if (value !== 'All') {
        const selectedCustomType = customTypes?.filter(
          (customType) => customType.name === value
        )[0];
        params.filter = [selectedCustomType._id, selectedFilter];
      } else {
        params.filter = [value, selectedFilter];
      }
    } else if (selectedFilter !== 'All') {
      const selectedCustomType = customTypes?.filter(
        (customType) => customType.name === selectedFilter
      )[0];
      params.filter = [selectedCustomType._id, value];
    } else {
      params.filter = [selectedFilter, value];
    }

    history.push({
      pathname: `/content`,
      search: qs.stringify(params)
    });
  };

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={data.length} title="Content" />
      <NoxTable
        columns={columns}
        customTypes={customTypes}
        data={data}
        dragAndDropUrl="content"
        filterContentModel={filterListContentModel}
        filterList={[filterListContentModel, filterListStatus]}
        filterStatus={filterListStatus}
        isDragAndDropEnabled
        isSearch
        loading={isLoadingContent && isLoadingContentModel}
        onFilterChange={onFilterChange}
        onPageChange={fetchContent}
        selectedFilter={getInitialFilterFromUrl()}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        totalPages={contentData?.paging.total}
      />
    </div>
  );
};

export default Highlighted;
